import { graphql, StaticQuery } from "gatsby"
import MultiSelect from "multiselect-react-dropdown"
import React, { useState } from "react"
import SVGIcon from "../../components/common/SVGIcon"
import "../../styles/component/select.scss"

let SelectOld = props => {
  const { choices, label } = props
  const [selectedValues, setSelectedValues] = useState([])

  const arrOfStr = () => {
    return selectedValues.map(item => {
      return item.label
    })
  }

  function handleValueChange(val) {
    setSelectedValues(val)
    props.onChange(val)
  }

  let customStyles = {
    multiselectContainer: {
      height: "45px",
      border: "1px solid #170426",
      "margin-bottom": "24px",
      "border-radius": "5px",
      cursor: "pointer",
    },
    searchBox: {
      height: "100%",
      padding: "0",
      border: "none",
      overflow: "hidden",
    },
    inputField: {
      margin: "0",
      // border: "none",
      height: "100%",
      position: "absolute",
      left: "0",
    },
    chips: {
      background: "transparent",
      // color: "#170426",
      "font-weight": "500",
      "font-size": "14px",
      "line-height": "14px",
      height: "100%",
      margin: "0",
      paddingRight: "0",
    },
    option: {
      display: "flex",
      alignItems: "center",
    },
  }

  function makeChoices(data) {
    return data.map(dt => ({ label: dt, value: dt }))
  }

  return (
    <StaticQuery
      query={graphql`
        query currentListOptions {
          SuperOps {
            links(where: { section: "current_tool_set" }) {
              section
              linkName
              slug
              icon {
                url
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <div title={arrOfStr().toString()}>
            <MultiSelect
              placeholder=""
              options={makeChoices(
                props.name === "region" || "category"
                  ? choices
                  : data.SuperOps.links[0].linkName
              )}
              onSelect={handleValueChange}
              onRemove={handleValueChange}
              displayValue={"label"}
              closeOnSelect={false}
              showCheckbox={true}
              showArrow={true}
              singleSelect={props.name === "region"}
              selectedValues={selectedValues}
              avoidHighlightFirstOption={true}
              hidePlaceholder={true}
              style={customStyles}
              customArrow={<SVGIcon name="arrow-down" />}
            />
            <span
              className={`floating-label p14 position-absolute ${
                selectedValues.length > 0 ? "option-selected" : ""
              }`}
            >
              <p>{label}</p>
            </span>
          </div>
        )
      }}
    />
  )
}

export default SelectOld
